import { getStore } from './store';
import { actionTypes } from './action-types';
import { clearFieldErrors, clearFieldValue, registerForm, resetForm, setFieldErrors, setFieldValue, setFieldValues, submitForm, unregisterForm } from './actions/form-actions';
import { registerService, setParamValue, setParamValues, submitService, unregisterService } from './actions/service-actions';
import { closeOverlay, closeAllOverlays, openOverlay } from './actions/overlay-actions';
var actions = {
  clearFieldErrors: clearFieldErrors,
  clearFieldValue: clearFieldValue,
  closeAllOverlays: closeAllOverlays,
  closeOverlay: closeOverlay,
  openOverlay: openOverlay,
  registerForm: registerForm,
  registerService: registerService,
  resetForm: resetForm,
  setFieldErrors: setFieldErrors,
  setFieldValue: setFieldValue,
  setFieldValues: setFieldValues,
  setParamValue: setParamValue,
  setParamValues: setParamValues,
  submitForm: submitForm,
  submitService: submitService,
  unregisterForm: unregisterForm,
  unregisterService: unregisterService
};
export { getStore, actions, actionTypes };